var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Button from "@irati/ui/src/Button";
import FlexWrapper from "./styled/FlexWrapper";
import FlexColumn from "./styled/FlexColumn";
import ImageWrapper from "./styled/ImageWrapper";
import ImagePreview from "./styled/ImagePreview";
var UploadedImage = /** @class */ (function (_super) {
    __extends(UploadedImage, _super);
    function UploadedImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UploadedImage.prototype, "value", {
        get: function () {
            var _a = this.props, benefit = _a.benefit, property = _a.property;
            return benefit[property];
        },
        enumerable: false,
        configurable: true
    });
    UploadedImage.prototype.render = function () {
        var _a = this.props, onDelete = _a.onDelete, property = _a.property;
        if (!this.value) {
            return null;
        }
        return React.createElement(React.Fragment, null,
            React.createElement(FlexWrapper, null,
                React.createElement(ImageWrapper, null,
                    React.createElement(ImagePreview, { alt: "preview", src: this.value })),
                React.createElement(FlexColumn, null,
                    React.createElement(Button, { small: true, onClick: function () { return onDelete(property, null); } },
                        React.createElement(Icon, { icon: IconTypes.bin, small: true, marginRight: true }),
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.uploadedImage.deleteButton.text" })))));
    };
    return UploadedImage;
}(Component));
export default UploadedImage;
